/**
 * @file NativeModal atom — react-native Modal overlay container.
 * @description Thin re-export of react-native's `Modal` (the full-screen
 * native overlay container with `visible`/`transparent`/`animationType`/
 * `onRequestClose`). This is the sanctioned atom-layer path for app code that
 * needs RN's native Modal behaviour, as distinct from the `Modal` atom — which
 * is the Gluestack centered-dialog family (`isOpen` + compound parts). Keeping
 * both behind the atom layer satisfies the import-closure ban (RFC §3/§5)
 * without forcing a behavioural rewrite of native-modal surfaces.
 * @module components/atoms/NativeModal
 */
export { Modal as NativeModal } from "react-native";
